import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GeneralConfigType, LocalService, Paging, PagingMembers, PagingSellers } from '../../../service/local.service';

@Component({
  selector: 'app-paging-search-filter',
  templateUrl: './paging-search-filter.component.html',
  styleUrls: ['./paging-search-filter.component.scss']
})
export class PagingSearchFilterComponent implements OnInit {
  @Input() paging: Paging; iShowDropDownIndex = 0; @Output() onSearchKeyEntered = new EventEmitter();
  @Output() onShoppingClicked = new EventEmitter();
  @Output() onCountryChanged = new EventEmitter(); @Input() isShowFilterOption = true;
  @Input() width = '100%'; @Input() isShowSearchButton = false; @Input() isShowShoppingCart = false;
  elementIds; @Input() isFooter = true; @Input() isTriggerOnOptionSelect = false; @Input() countToShow = 0;
  qrCodeTypes = [GeneralConfigType.PagingMembers, GeneralConfigType.PagingSellers, GeneralConfigType.PagingComplaints];

  constructor(public localService: LocalService) { }

  ngOnInit(): void {
    let htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      dd_paging_search_type: 'dd_paging_search_type_' + htmlId,
      btn_paging_search_type: 'btn_paging_search_type_' + htmlId
    };
  }


  onShowHideDropDown(index, isHide = false) {
    this.iShowDropDownIndex = isHide || this.iShowDropDownIndex == index ? 0 : index;
    switch (this.iShowDropDownIndex) {
      case 1: {
        this.localService.onFocusFooterDropDown(this.elementIds.btn_paging_search_type, this.elementIds.dd_paging_search_type, this.elementIds.dd_paging_search_type + '_' + this.paging.searchType, this.isFooter);
      } break;
    }
  }

  onSelect() {
    if (this.isTriggerOnOptionSelect) {
      this.onSearch();
    }
  }

  onSearch() {
    this.onSearchKeyEntered.emit();
  }

  onInput() {
    if (this.qrCodeTypes.includes(this.paging.pageType)) {
      let item = this.localService.getDecodedQrCode(this.paging.searchKey);
      if (item && item.isValid) {
        switch (this.paging.pageType) {
          case GeneralConfigType.PagingMembers: {
            this.paging.searchType = PagingMembers.IdOrQR;
          } break;
          case GeneralConfigType.PagingSellers: {
            this.paging.searchType = PagingSellers.IdOrQR;
          } break;
        }
        this.onCountryChanged.emit(item.countryCode);
        this.paging.searchKey = this.paging.pageType == GeneralConfigType.PagingSellers ? item.businessId : item.value;
        this.onSearchKeyEntered.emit();
      }
    }
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        this.onShoppingClicked.emit();
      } break;
    }
  }
}
